export const directories = {

    'boot': {
        'doc.txt': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam a venenatis ex. Proin placerat risus nisl, sit amet cursus massa tincidunt id. Phasellus facilisis ullamcorper consectetur. Aliquam pharetra sapien quis nunc volutpat, nec egestas purus fringilla'
    },
    'usr': {
        'bin': null,
        'lib': null,
        'share': null,
        'include': null
    },
    'etc': null,
    'home': {
        'user': {
            'desktop': {
                'myfolder': {
                    'myfile.txt': 'Nunc vitae tincidunt risus. Praesent quis lorem eu nunc sollicitudin pellentesque. Integer sollicitudin leo consequat, pulvinar purus et, tincidunt sapien. Curabitur sodales suscipit metus eu ullamcorper. '
                }
            },
            'picrures': null,
            'music': null
        },
        'root': {
            'desktop': null,
            'picrures': null,
            'music': null
        }
    },
    'dev': null,
    'proc': null

}